import { render, staticRenderFns } from "./AndiamoErogazioneEditPage.vue?vue&type=template&id=95d43640&scoped=true"
import script from "./AndiamoErogazioneEditPage.vue?vue&type=script&lang=js"
export * from "./AndiamoErogazioneEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d43640",
  null
  
)

export default component.exports